import { Helmet } from "react-helmet-async";
import LandingItalyBanner from "../landingPages/landingItaly/LandingItalyBanner";
import LandingItalyLaunch from "../landingPages/landingItaly/LandingItalyLaunch";
import LandingItalyWorks from "../landingPages/landingItaly/LandingItalyWorks";
import LandingItalyChoose from "../landingPages/landingItaly/LandingItalyChoose";
import LandingItalyApps from "../landingPages/landingItaly/LandingItalyApps";
import LandingItalyGet from "../landingPages/landingItaly/LandingItalyGet";
import LandingItalyMarket from "../landingPages/landingItaly/LandingItalyMarket";
import LandingItalyGo from "../landingPages/landingItaly/LandingItalyGo";
import ShuttleAppreciation from "../shuttle_software/ShuttleAppreciation";
import TaxiFaq from "../taxiDispatchSoftware/TaxiFaq";
import OnDemandWork from "../cloneApps/onDemand/OnDemandWork";

const BannerData = {
  title: "Advanced Bus Fleet Management Software",
  desc: "Empower your transportation operations with a fully customizable bus fleet management software solution. Get a passenger app, driver app, dispatcher panel, and admin dashboard, all seamlessly integrated to simplify operations, improve route planning, and manage your fleet efficiently.",
  demo: "21 Days Free Trial | No Credit Card Required",
  cta1: "book free demo",
  cta2: "Explore Features",
  slideText: "Trusted by 1,000+ Companies Worldwide",
  bannerImg:"/assets/home/busmanage-banner.webp"
}

const goData = {
  title: "Why Pick A Bus Fleet Management Solution?",
  subTitle: "Your Brand, Our Technology: A Winning Combination",
  desc: "Skip the hassle of building a platform from scratch. Our white-label bus management solution delivers a fully production-ready system that integrates with your brand, logo, colors, and domain. Upgrade your operations with powerful transportation management software featuring real-time tracking, automation, and smart routing. Focus on scaling your transportation services while we handle the technical complexities.",
  rightImg:"/assets/home/pick-bus-fleet.webp",
  cta: "get started",
  cta2: "Schedule a free Demo",
  cta3: "Explore More",
  boxes: [
    {
      title: "Passenger & Driver Apps",
      desc: "Android and iOS apps with seamless onboarding, intuitive UI, trip booking, route tracking, and features supporting efficient Bus Fleet Management operations.",
      image: "/assets/home/land2-rider-1.webp",
    },
    {
      title: "Real-Time Tracking",
      desc: "Monitor buses and trips live to improve passenger safety, operational visibility, and service reliability with GPS-powered tracking in your Bus Fleet Management System.",
      image: "/assets/home/land2-rider-2.webp",
    },
    {
      title: "In-App Notifications",
      desc: "Keep passengers and drivers informed with real-time alerts for trip confirmations, arrivals, route updates, and important notifications.",
      image: "/assets/home/land2-rider-3.webp",
    },
    {
      title: "Payment Gateway Integration",
      desc: "Enable secure payments through cards, wallets, and digital methods, ensuring seamless fare collection and convenient transactions within your Transportation Management Software.",
      image: "/assets/home/land2-rider-4.webp",
    },
    {
      title: "Auto & Manual Dispatching",
      desc: "Assign the nearest available driver automatically or dispatch buses manually for scheduled routes and special trips, ensuring flexible fleet control through reliable Bus Dispatch Software.",
      image: "/assets/home/land2-rider-5.webp",
    },
    {
      title: "Admin Dashboard & Analytics",
      desc: "Track revenue, trip activity, fleet performance, and passenger usage through a centralized dashboard with analytics for data-driven decisions.",
      image: "/assets/home/land2-rider-6.webp",
    },
  ]
}

const marketData = {
  titlePart1: "Smart Transport",
  titlePart2: " Connectivity",
  desc: "Partner with Mobility Infotech to streamline operations, optimize routes, and scale your Bus Fleet Management Solution with confidence.",
  cta: "Get in touch",
}

const getData = {
  title: 'What You Get',
  subTitle: "Everything You Need to Manage Your Bus Fleet Efficiently",
  desc: "Enhance transportation efficiency with our AI-powered Transportation Routing Software and Bus Dispatch Software. The platform is designed to improve passenger experience, optimize fleet operations, and simplify management."
}

const appData = {
  title: "Passenger App",
  desc: "Our intuitive passenger application makes bus booking and trip management simple and efficient.",
  cta: "Schedule a free Demo",
  rightImg:"/assets/home/bus-pasenger-app.webp",
  boxes: [
    {
      title: "Quick & Easy Booking",
      desc: "Passengers can book bus rides or reserve seats instantly through the mobile app, creating a convenient and user-friendly Transportation Management Software experience.",
      image: "/assets/home/land2-app-logo-1.webp",
    },
    {
      title: "Fare Estimates",
      desc: "Provide transparent fare calculations and route pricing before confirmation, ensuring clarity and trust in your Bus Fleet Management System.",
      image: "/assets/home/land2-app-logo-2.webp",
    },
    {
      title: "Real-Time Bus Tracking",
      desc: "Passengers can track the live location of buses using integrated GPS within the Transportation Routing Software, improving travel confidence and planning.",
      image: "/assets/home/land2-app-logo-3.webp",
    },
    {
      title: "Multiple Payment Methods",
      desc: "Support payments through cashless options such as cards, mobile wallets, or digital payments to ensure flexible transactions.",
      image: "/assets/home/land2-app-logo-4.webp",
    },
  ]
}

const appData1 = {
  title: "Driver App",
  desc: "Equip drivers with essential tools through a dedicated mobile application connected to the Bus Dispatch Software.",
  leftImg:"/assets/home/bus-driver-app.webp",
  boxes: [
    {
      title: "Trip Assignments",
      desc: "Drivers receive route assignments instantly with the option to accept or decline requests within seconds.",
      image: "/assets/home/land2-app-logo-1.webp",
    },
    {
      title: "Built-In Navigation Support",
      desc: "Integrated GPS and traffic-aware navigation within the Transportation Routing Software helps drivers reach destinations efficiently while reducing delays.",
      image: "/assets/home/land2-app-logo-2.webp",
    },
    {
      title: "Earnings & Performance Tracking",
      desc: "Drivers can monitor completed trips, earnings, schedules, and performance metrics through a clean and intuitive interface.",
      image: "/assets/home/land2-app-logo-3.webp",
    },
    {
      title: "Identity Verification",
      desc: "Driver documentation and identity verification can be securely approved by administrators through the Bus Fleet Management System.",
      image: "/assets/home/land2-app-logo-4.webp",
    },
  ]
}

const appData2 = {
  title: "Admin Dashboard",
  desc: "A centralized control panel designed to manage every aspect of your Bus Fleet Management Software.",
  boxes: [
    {
      title: "Real-Time Monitoring",
      desc: "Track buses, routes, driver availability, and ongoing trips instantly to maintain operational efficiency.",
      image: "/assets/home/land2-app-logo-5.webp",
    },
    {
      title: "Detailed Reports & Analytics",
      desc: "Access comprehensive reports on fleet performance, route efficiency, passenger demand, and revenue generated through your Transportation Management Software.",
      image: "/assets/home/land2-app-logo-6.webp",
    },
    {
      title: "Fleet & Driver Management",
      desc: "Add or remove buses, assign drivers, update routes, and configure pricing—all from a single Bus Fleet Management Software dashboard.",
      image: "/assets/home/land2-app-logo-7.webp",
    },
    {
      title: "Corporate & Institutional Transport Management",
      desc: "The platform allows organizations to manage employee transportation, schedule buses, set fare structures, and assign vehicles through the Bus Fleet Management Solution.",
      image: "/assets/home/land2-app-logo-8.webp",
    },
  ]
}

const appData3 = {
  title: "Dispatcher Panel",
  desc: "Provide dispatch teams with powerful tools to manage transportation operations effectively.",
  boxes: [
    {
      title: "Manual Route Assignment",
      desc: "Dispatchers can manually assign buses for specific routes, emergency trips, or special events using the Bus Dispatch Software.",
      image: "/assets/home/land2-app-logo-9.webp",
    },
    {
      title: "Live Fleet Overview",
      desc: "View the real-time status of active, available, and offline buses through a centralized Bus Fleet Management Software dashboard.",
      image: "/assets/home/land2-app-logo-10.webp",
    },
    {
      title: "Automated Dispatch",
      desc: "Our intelligent Bus Dispatch Software automatically assigns vehicles based on proximity, route optimization, and scheduling.",
      image: "/assets/home/land2-app-logo-3.webp",
    },
    {
      title: "Efficient Route Allocation",
      desc: "Optimized routing through the Transportation Routing Software minimizes delays, reduces fuel consumption, and increases fleet productivity.",
      image: "/assets/home/land2-app-logo-11.webp",
    },
  ]
}

const chooseData = {
  titlePart1: "Why Choose ",
  titlePart2: "Mobility Infotech?",
  subTitle: " Because we care about your transportation business.",
  desc: "We deliver more than software, we provide expertise in mobility technology that helps transportation companies scale efficiently with a reliable Bus Fleet Management Solution.",
  ctaTitle: "Mobility Infotech: A Smarter Way to Manage Your Bus Transportation Network",
  cta1: "Schedule a free Demo",
  cta2: "Explore More",
  boxes: [
    {
      title: "Scalability",
      desc: "Easily scale your operations with a Bus Fleet Management System built to support growing fleets and rising passenger demand.",
      image: "/assets/home/land2-choose-icon-1.webp",
    },
    {
      title: "24/7 Support",
      desc: " Our dedicated support team ensures your Transportation Management Software runs smoothly whenever you need assistance.",
      image: "/assets/home/land2-choose-icon-2.webp",
    },
    {
      title: "Secure Platform",
      desc: "Enterprise-grade security safeguards fleet data, passenger information, and operational systems at all times.",
      image: "/assets/home/land2-choose-icon-3.webp",
    },
    {
      title: "Cost-Effective Pricing",
      desc: "Flexible pricing plans make our Bus Fleet Management Software suitable for organizations of every size.",
      image: "/assets/home/land2-choose-icon-4.webp",
    },
    {
      title: "High Configurability",
      desc: "Customize routes, pricing, user access, and workflows to match your unique transportation operations.",
      image: "/assets/home/land2-choose-icon-5.webp",
    },
    {
      title: "Easy Integration",
      desc: "Seamlessly connect payment systems, GPS providers, and analytics tools with your Transportation Management Software.",
      image: "/assets/home/land2-choose-icon-6.webp",
    },
  ]
}

const workData = {
  title: 'How It Works',
  desc: "Launch Your Bus Fleet Management Platform in 3 Simple Steps",
  boxes: [
    {
      title: "Tell Us About Your Brand",
      desc: "Share your branding details, including logo, colors, and platform requirements for your customized Bus Fleet Management Solution.",
    },
    {
      title: "We Set Everything Up",
      desc: "Our team configures the mobile apps, admin panel, routing tools, and domain for your Transportation Management Software.",
    },
    {
      title: "Go Live",
      desc: "Start managing routes, dispatching buses, and serving passengers seamlessly using your fully operational Bus Fleet Management System.",
    },
  ]

}

const launchData = {
  title: "Launch Your Bus Management Platform: Under Your Brand",
  desc: "Get branded passenger and driver apps, an admin panel, and a powerful bus dispatch system: No coding required!",
  cta1: "Schedule a Free Demo",
  cta2: "Explore Features",
}

const faqData = [
  {
    id: "0",
    question: "01. What is a Bus Fleet Management Software?",
    answer: "Bus Management Software is a centralized platform that allows transport operators to monitor buses, manage drivers, optimize routes, track trips in real-time, and analyze fleet performance. It enhances operational efficiency, reduces delays, and improves passenger satisfaction across your transportation network.",
  },
  {
    id: "1",
    question: "02. How does Transportation Routing Software improve efficiency?",
    answer: "Transportation Routing Software optimizes bus routes using real-time traffic data, passenger demand, and fleet availability. Automating route planning reduces fuel costs, prevents delays, and ensures timely arrivals, making your fleet more productive while improving customer service and operational transparency.",
  },
  {
    id: "2",
    question: "03. Can I customize the Bus Fleet Management Solution for my brand?",
    answer: "Yes, our Bus Fleet Management Solution can be fully branded with your logo, colors, and domain. This white-label approach ensures consistency with your corporate identity while providing a ready-to-use, scalable platform to manage buses, drivers, and passenger services efficiently.",
  },
  {
    id: "3",
    question: "04. What features are included in Bus Dispatch Software?",
    answer: "Bus Dispatch Software provides automated and manual vehicle assignment, real-time fleet tracking, route optimization, driver notifications, and performance monitoring. These features help dispatchers efficiently manage trips, respond to emergencies, and maintain smooth operations across your entire bus fleet system.",
  },
  {
    id: "4",
    question: "05. Is the Bus Fleet Management System suitable for large fleets?",
    answer: " Yes, the Bus Fleet Management System is designed for scalability. Whether you manage a small or large fleet, it can handle multiple buses, routes, and drivers while providing real-time tracking, analytics, and reporting to ensure seamless operations and improved transport management.",
  },
];


export default function BusManagement() {
  return (
    <>
      <LandingItalyBanner data={BannerData} />
      <LandingItalyGo data={goData} />
      <LandingItalyMarket data={marketData} />
      <LandingItalyGet data={getData} />
      <LandingItalyApps data={appData} data1={appData1} data2={appData2} data3={appData3} />
      <LandingItalyChoose data={chooseData} />
      <LandingItalyWorks data={workData} />
      <div className="solution-case">
        <OnDemandWork filterData={"Taxi app"} />
      </div>
      <section className="land2-testimonial"><ShuttleAppreciation /></section>
      <section className="land2-faq"><TaxiFaq faqData={faqData} /></section>
      <LandingItalyLaunch data={launchData} />
    </>
  )
}
